import React from "react";
import "./ConfirmModal.scss";

export function ConfirmModal({ open, message, onConfirm, onCancel, danger = false, confirmLabel = "Aceptar", cancelLabel = "Cancelar" }) {
  if (!open) return null;
  return (
    <div className="cm-overlay" onClick={onCancel}>
      <div className="cm-modal" onClick={e => e.stopPropagation()}>
        <p className="cm-msg">{message}</p>
        <div className="cm-actions">
          <button className={`cm-btn cm-btn--confirm${danger ? " cm-btn--danger" : ""}`} onClick={onConfirm}>{confirmLabel}</button>
          <button className="cm-btn cm-btn--cancel" onClick={onCancel}>{cancelLabel}</button>
        </div>
      </div>
    </div>
  );
}
